const getStoreItems = (state) => state.stores?.storeItems;
const getSimilarStores = (state) => state.stores?.similarStores;
const getBranchesList = (state) => state.stores?.branchesList;
const getBranchesFilters = (state) => state.stores?.branchesList?.ApplyFilter;
const getImageList = (state) => state.stores?.storeItems?.ImageList;
const getWidgets = (state) => state?.stores?.widgets || [];
const getInstallments = (state) => state?.stores?.installment;

export {
	getStoreItems,
	getWidgets,
	getSimilarStores,
	getBranchesList,
	getImageList,
	getBranchesFilters,
	getInstallments,
};
